import { UserRole } from '@/shared/api';

export const USER_ROLE_LABELS: Record<UserRole, string> = {
	[UserRole.User]: 'Пользователь',
	[UserRole.CommunityManager]: 'Коммьюнити менеджер',
	[UserRole.Editor]: 'Редактор',
	[UserRole.Admin]: 'Администратор',
};

export const USER_ROLE_OPTIONS: Array<{
	value: UserRole;
	label: string;
	description: string;
}> = [
	{
		value: UserRole.User,
		label: USER_ROLE_LABELS[UserRole.User],
		description: 'Обычный пользователь',
	},
	{
		value: UserRole.CommunityManager,
		label: USER_ROLE_LABELS[UserRole.CommunityManager],
		description: 'Имеет доступ к CRM',
	},
	{
		value: UserRole.Editor,
		label: USER_ROLE_LABELS[UserRole.Editor],
		description: 'Может редактировать контент',
	},
	{
		value: UserRole.Admin,
		label: USER_ROLE_LABELS[UserRole.Admin],
		description: 'Полный доступ к административным функциям',
	},
];
